const { VUE_APP_QLIK_HOST: host } = process.env;

export default {
  host,
  prefix: "/login/",
  port: "443",
  protocol: "https://",
  isSecure: true
};
